import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import { ActivationLogs } from './ActivationLogs';

export default withStyles(styles)(ActivationLogs);
